import type { WorkflowCapabilities } from '@jira/project-settings__workflow-types/src/workflowTypes.types.tsx';
import {
	createResource,
	useResource,
	type ResourceStoreContext,
	type RouterDataContext,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_PROJECT_WORKFLOW_CONTEXT } from '@atlassian/jira-router-resources-project-workflow-context/src/services/project-workflow-context/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { fetchWorkflowCapabilities, fetchWorkflowCapabilitiesOld } from './services/index.tsx';

export const RESOURCE_TYPE_KEY = 'ADMIN_WORKFLOW_CAPABILITIES';

export const workflowCapabilitiesResource =
	// eslint-disable-next-line jira/router/no-daisy-chaining-resources
	createResource<WorkflowCapabilities>({
		type: RESOURCE_TYPE_KEY,
		depends: [RESOURCE_TYPE_PROJECT_WORKFLOW_CONTEXT],
		getKey: (matchedRoute) => {
			const { workflowId } = matchedRoute.match.params;
			return `${RESOURCE_TYPE_KEY}_${workflowId}`;
		},
		getData: async (routerContext: RouterDataContext, customContext: ResourceStoreContext) =>
			fg('hix-7599_support_projectdetails_resource_in_tmp')
				? fetchWorkflowCapabilities(routerContext, customContext)
				: fetchWorkflowCapabilitiesOld(routerContext, customContext),
		maxAge: 0,
		isBrowserOnly: true,
	});

export const useWorkflowCapabilities = () =>
	useResource<WorkflowCapabilities>(workflowCapabilitiesResource);
